import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import { TaxReason } from 'src/features/taxReasons/utils/types';
import { useCreateTaxReason } from 'src/features/taxReasons/api/useCreateTaxReason';
import { LIST_TAX_REASONS_RESOURCE } from 'src/features/taxReasons/api/useListTaxReasons';
import { taxReasonsMessages } from 'src/features/taxReasons/utils/messages';
import TaxReasonFormModal from 'src/features/taxReasons/components/forms/TaxReasonFormModal';

interface CreateTaxReasonFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedTaxReason?: TaxReason;
    children?: React.ReactNode;
}

function CreateTaxReasonFormModal<TData>({ className, semantics }: CreateTaxReasonFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useCreateTaxReason({
        onSuccess: (success) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_TAX_REASONS_RESOURCE] });
            toast({
                title: formatMessage(taxReasonsMessages.createTaxReasonSuccess),
                description: formatMessage(taxReasonsMessages.createTaxReasonSuccessDescription, {
                    entry: success.name,
                }),
            });
        },
    });

    return (
        <TaxReasonFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate(values, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(taxReasonsMessages.addTaxReasonSubtitle)}
        />
    );
}

export default CreateTaxReasonFormModal;
